import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import i18next from "i18next";
var LandingComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.PrivateDiningLandingPage;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    },
    modules: ["private-dining/home.tsx -> " + "@dp/xcomp"]
  }
});

var HomePage = function HomePage() {
  var _store$common, _store$common$appAttr, _store$common$appAttr2, _store$common2, _store$common2$appAtt, _store$common2$appAtt2;

  var store = useStore();
  var router = useRouter();
  var conceptCode = store === null || store === void 0 ? void 0 : (_store$common = store.common) === null || _store$common === void 0 ? void 0 : (_store$common$appAttr = _store$common.appAttributes) === null || _store$common$appAttr === void 0 ? void 0 : (_store$common$appAttr2 = _store$common$appAttr.concept) === null || _store$common$appAttr2 === void 0 ? void 0 : _store$common$appAttr2.conceptCode;
  var conceptCodeDesc = store === null || store === void 0 ? void 0 : (_store$common2 = store.common) === null || _store$common2 === void 0 ? void 0 : (_store$common2$appAtt = _store$common2.appAttributes) === null || _store$common2$appAtt === void 0 ? void 0 : (_store$common2$appAtt2 = _store$common2$appAtt.concept) === null || _store$common2$appAtt2 === void 0 ? void 0 : _store$common2$appAtt2.conceptCodeDesc;
  useEffect(function () {
    store === null || store === void 0 ? void 0 : store.initComponent("PrivateDining").then(function () {//
    });
  }, []);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: i18next.t("text.private_dining.page.home.title", {
          defaultValue: "Private Dining Rooms | ".concat(conceptCodeDesc, " Restaurant")
        })
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: i18next.t("text.private_dining.page.home.metadescription", {
          defaultValue: "".concat(conceptCodeDesc, " offers private dining rooms for all occasions. Private dining rooms are available upon request. Learn more today.")
        })
      }), /*#__PURE__*/_jsx("script", {
        src: "https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js",
        defer: true
      }), /*#__PURE__*/_jsx("script", {
        src: "https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js",
        defer: true
      }), /*#__PURE__*/_jsx("link", {
        rel: "stylesheet",
        href: "/pd/common/common.css"
      }), conceptCode ? /*#__PURE__*/_jsx("link", {
        rel: "stylesheet",
        href: "/pd/css/".concat(conceptCode === null || conceptCode === void 0 ? void 0 : conceptCode.toLocaleLowerCase(), "_PD.css")
      }) : null]
    }), /*#__PURE__*/_jsx(LandingComp, {
      route: router === null || router === void 0 ? void 0 : router.asPath
    })]
  });
};

HomePage.layout = PageLayout.NB_LAYOUT;
HomePage.layoutProps = {
  analyticsData: {
    pageName: "private-dining home",
    pageType: "private-dining"
  }
};
export default observer(HomePage);